import React from 'react';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import { formatMonthKey, formatMonthLabel, shiftMonthKey } from '../../utils/workerStatsUtils';

const currentMonthKey = () => formatMonthKey(new Date().getFullYear(), new Date().getMonth());

const WorkerMonthPicker = ({ monthKey, onChange }) => (
  <div className="flex items-center justify-between gap-2 rounded-md border border-gray-700/70 bg-gray-900/40 px-2 py-1.5">
    <button
      type="button"
      onClick={() => onChange(shiftMonthKey(monthKey, -1))}
      className="p-1 rounded text-gray-400 hover:text-white hover:bg-gray-700/60 transition-colors"
      aria-label="Prethodni mesec"
    >
      <ChevronLeft className="h-4 w-4" />
    </button>
    <div className="flex items-center gap-1.5 min-w-0 flex-1 justify-center">
      <Calendar className="h-3.5 w-3.5 text-blue-400 flex-shrink-0" />
      <span className="text-xs font-semibold text-white truncate capitalize">
        {formatMonthLabel(monthKey)}
      </span>
    </div>
    <button
      type="button"
      onClick={() => onChange(shiftMonthKey(monthKey, 1))}
      className="p-1 rounded text-gray-400 hover:text-white hover:bg-gray-700/60 transition-colors"
      aria-label="Sledeći mesec"
      disabled={shiftMonthKey(monthKey, 1) > currentMonthKey()}
    >
      <ChevronRight className="h-4 w-4" />
    </button>
  </div>
);

export default WorkerMonthPicker;
